import { useSignupForm } from 'modules/auth/hooks/useSignupForm'
import { PropsWithChildren } from 'react'
import { FormProvider } from 'react-hook-form'

export const SignupFormProvider = ({ children }: PropsWithChildren) => {
  const form = useSignupForm()

  return (
    <FormProvider {...form}>
      <div className="flex flex-1 flex-col">{children}</div>
    </FormProvider>
  )
}
